module.exports = function(app) {
	app.directive('dateParser', ['$filter', function($filter){
		return {

			require: 'ngModel',

			link: function(scope, element, attrs, modelCtrl) {
				modelCtrl.$formatters.unshift(
					function(dateInput) {
						if (dateInput instanceof Date) {
							return Date;
						}
						if (dateInput.length === 10 && dateInput.indexOf('/') === 4) {
							var d = dateInput.split('/');
							dateInput = new Date(d[0], d[1] - 1, d[2]);
						}
						if (dateInput.length === 10 && dateInput.indexOf('/') === 2) {
							var d = dateInput.split('/');
							dateInput = new Date(d[2], d[0] - 1, d[1]);
						}
						return dateInput;
					}
				);
			}
		};
	}]);
};
